<app-print-layout (cancelar)="cancelar()" [printBodyClass]="'print-a3-landscape'">
  <div class="modal-body matriz-scroll">

    <div *ngFor="let secao of secoesConsolidadasVM" class="matriz-visualizacao">

      <div class="matriz-cabecalho">
        <div class="linha-ug text-center">
          <span class="texto fw-bold">{{ secao.unidadeGestoraNome || '-' }}</span>
        </div>
        <div class="linha-titulo text-center">
          MATRIZ DE CONSTATAÇÃO
          <span class="colchetes">DEFINITIVA</span>
          - OSA Nº <span class="texto">{{ secao.numeroOsa }}</span>
        </div>
      </div>

      <table class="table table-bordered table-sm matriz-tabela">
        <thead class="matriz-thead">
        <tr class="th-grupo text-center">
          <th class="col-num-desc text-center" colspan="2">DESCRIÇÃO DA CONSTATAÇÃO</th>
          <th class="col-sit text-center">SITUAÇÃO ENCONTRADA</th>
          <th class="col-risco text-center">RISCO VINCULADO</th>
          <th class="col-crit text-center">CRITÉRIOS INFRINGIDOS</th>
          <th class="col-ev text-center">EVIDÊNCIAS</th>
          <th class="col-causa text-center">CAUSAS</th>
          <th class="col-efeito text-center">EFEITOS</th>
          <th class="col-rec text-center">RECOMENDAÇÕES</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of secao.itensFinalizados">
          <td class="col-num-desc" colspan="2">
            <div class="d-flex align-items-start">
              <span>{{ item.identificador || '-' }}</span>
              <span class="descricao-texto">{{ item.descricaoConstatacao || '-' }}</span>
            </div>
          </td>
          <td class="col-sit">{{ item.situacaoEncontrada || '-' }}</td>
          <td class="col-risco">{{ item.riscosVinculados || '-' }}</td>
          <td class="col-crit">
            <ng-container *ngIf="item.criteriosInfringidos; else semCriterios">
              <div *ngFor="let linha of item.criteriosInfringidos.split('\n')">{{ linha }}</div>
            </ng-container>
            <ng-template #semCriterios><span class="text-muted">-</span></ng-template>
          </td>
          <td class="col-ev col-evidencias">
            <div class="evidencias-box">
              <ng-container *ngIf="item.evidenciasDetalhadas?.length > 0; else semEvidencias">
                <div *ngFor="let ev of item.evidenciasDetalhadas" class="evidencia-item">
                    <span class="evidencia-icone">
                      <i class="fas fa-paperclip" *ngIf="ev.tipo === 1"></i>
                      <i class="fas fa-link"      *ngIf="ev.tipo === 2"></i>
                      <i class="fas fa-align-left" *ngIf="ev.tipo === 3"></i>
                    </span>
                  <span *ngIf="ev.tipo === 1" class="text-dark">
                      {{ ev.nomeArquivo || extrairTextoSemPrefixo(ev.texto) }}
                    </span>
                  <a *ngIf="ev.tipo === 2"
                     [href]="formatarUrl(extrairTextoSemPrefixo(ev.texto))"
                     target="_blank" rel="noopener"
                     class="text-primary evidencia-link">
                    {{ extrairTextoSemPrefixo(ev.texto) }}
                  </a>
                  <span *ngIf="ev.tipo === 3" class="text-dark evidencia-texto">
                      {{ extrairTextoSemPrefixo(ev.texto) }}
                    </span>
                </div>
              </ng-container>
              <ng-template #semEvidencias><span class="text-muted">-</span></ng-template>
            </div>
          </td>
          <td class="col-causa">{{ item.causa || '-' }}</td>
          <td class="col-efeito">{{ item.efeito || '-' }}</td>
          <td class="col-rec">
            <div *ngFor="let linha of formatarRecomendacoes(item.recomendacoes).split('\n')">
              {{ linha }}
            </div>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>
</app-print-layout>
